import { createContext, useEffect, useState } from 'react'

export const NavigationMenuContext = createContext<{
    expanded: { [key: string]: string | false };
    handleNavigationChange: (level: string, panel: string) => void;
    clearMenuSelection: () => void
}>({
    expanded: {},
    handleNavigationChange: (level: string, panel: string) => { },
    clearMenuSelection: () => { }
});

export const NavigationMenuContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [expanded, setExpanded] = useState<{ [key: string]: string | false }>(
        {
            'root': 'root',
            'root-REST APIs': 'root-REST APIs',
            'root-REST APIs-Guides': 'root-REST APIs-Guides',
            'root-REST APIs-Guides-Overview': 'root-REST APIs-Guides-Overview',
        }
    );
    const [activeItem, setActiveItem] = useState<MenuItem | null>(null);

    const clearMenuSelection = () => {
        setExpanded((prevExpanded) => ({}));
    }

    const handleChange = (level: string, panel: string) => {
        setExpanded((prevExpanded) => ({
            ...prevExpanded,
            [level]: prevExpanded[level] === panel ? false : panel,
        }));
    };

    useEffect(() => {
        if (!activeItem) {
            const defaultItem: MenuItem = { title: 'Overview', path: 'REST APIs/Guides/Overview' };
            setActiveItem(defaultItem);
            let level = 'root';
            let panel = 'root';
            defaultItem.path.split('/').forEach((path: string) => {
                panel = panel + '-' + path;
                handleChange(level, panel);
                level = level + '-' + path;
            });
        }
    }, [activeItem]);


    const navigationCtx = {
        expanded: expanded,
        handleNavigationChange: handleChange,
        clearMenuSelection: clearMenuSelection
    };

    return <NavigationMenuContext.Provider value={navigationCtx} >
        {children}
    </NavigationMenuContext.Provider>
} 